import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LazyLoadEvent } from 'primeng/api';

@Component({
    selector: 'app-test-activation',
    templateUrl: './test-activation.component.html',
    styleUrls: ['./test-activation.component.scss']
})
export class TestActivationComponent implements OnInit {
  @Input() public column : Array<{}> = [];
  @Input() public testActivationReport : Array<object> = [];
  @Input() public totalRecords: number;
  @Output() public eventVal: EventEmitter<LazyLoadEvent> = new EventEmitter<LazyLoadEvent>();
  public constructor() { }

  public ngOnInit(): void {}
  public onLazyLoad(event:LazyLoadEvent) : void {
      this.eventVal.emit(event);
  }
}
